import { Box, Divider, Typography } from "@mui/material";
import { React, useState } from "react";
import AppButton from "../../../../../base/AppButton.component";
import { CheckCircle } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
const DeactivateUserDialog = ({
  deactivateHandler,
  is_active,
  activateHandler,
}) => {
  const [actionSuccess, setActionSuccess] = useState(false);
  const theme = useTheme();

  const toggleUserStatus = () => {
    if (!is_active) {
      activateHandler();
    } else {
      deactivateHandler();
    }
    setActionSuccess(true);
  };

  return (
    <>
      <Divider sx={{ marginBottom: "24px" }} />
      <Typography
        variant="h6"
        sx={{ display: "flex", justifyContent: "center" }}
      >
        {`Are you sure you want to ${
          is_active ? "Deactivate" : "Activate"
        } User?`}
      </Typography>
      <Divider sx={{ marginBottom: "24px", marginTop: "24px" }} />
      {actionSuccess ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CheckCircle color={"primary"} />
          <span
            style={{ color: theme.palette.primary.main, marginLeft: "4px" }}
          >
            SUCCESS
          </span>
        </Box>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <AppButton
            sx={{ width: "200px", alignItems: "center" }}
            buttonText={is_active ? "Deactivate User" : "Activate User"}
            clickHandler={toggleUserStatus}
          />
        </Box>
      )}
    </>
  );
};

export default DeactivateUserDialog;
